<input type="text" [placeholder]="placeholder" (focus)="onFocus()" (focusout)="onFocusOut()" [name]="name" [id]="name"
  [(ngModel)]="displayValue" [required]="required" [readOnly]="readonly" [class]="classes" #numberInput="ngModel"
  [disabled]="disabled" (paste)="onPaste($event)" [attr.aria-label]="name" autocomplete="off" (blur)="onBlur()"
  percentFormatter [needPercentFormatter]="needPercentFormatter" />
